import Flickity from 'flickity';

class FlickitySlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.flickity__slider');
    if (!this.slider) return;

    this.options = this.slider.dataset.flickityConfig ? JSON.parse(this.slider.dataset.flickityConfig) : {};

    this.flkty = new Flickity(this.slider, this.options);

    this.init.bind(this);
  }

  init() {
    if (this.flkty) this.flkty.resize();
  }
}

customElements.define('flickity-slider', FlickitySlider);
window.FlickitySlider = FlickitySlider;
